import { render, staticRenderFns } from "./MainMenuComponent.vue?vue&type=template&id=8dadddf6"
import script from "./MainMenuComponent.vue?vue&type=script&lang=js"
export * from "./MainMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./MainMenuComponent.vue?vue&type=style&index=0&id=8dadddf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports